module.exports = __webpack_public_path__ + "static/img/guard_wang.e87339b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/guard/guard_wang.png
// module id = PO9j
// module chunks = 0